export default "__VITE_ASSET__o2Vh0GM3__"